module.exports = __webpack_public_path__ + "img/twitter.50b1dee1.svg";